import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import FingerprintJS from "@com-banistmo/fingerprintjs";
import { ApiGateway } from "@settings/models/enviroment-consts/api-gateway";
import { BehaviorSubject, firstValueFrom, Observable } from "rxjs";
import { ConfigService } from "../config/config.service";
import { AppJwtHelperService } from "./jwt-helper-service";

@Injectable({
  providedIn: "root",
})
export class DataService {
  public token: string = "";
  public clientId: string | null = "";
  public username: string = "";
  public isMobile: boolean = false;
  public otp: string | undefined = "";
  public redirectURI: string | null = "";
  public state: string | null = "";
  public mfa_token: string | null = "";
  public nonce: string | null = "";
  public multiSessionToken: string = "";
  public captchaValue: string = "";
  public codeChallenge: string | null = "";
  public codeMethodChallenge: string | null = "";
  public responseType: string | null = "";

  private readonly $keyPublic = new BehaviorSubject<string | null>(null);
  constructor(
    private http: HttpClient,
    private appJwtHelper: AppJwtHelperService,
    private configService: ConfigService
  ) {}

  public setSessionData(token: string, isMobile?: boolean, otp?: string) {
    this.setToken(token);
    this.isMobile = isMobile === true;
    this.otp = otp;
  }

  public setToken(token: string) {
    this.token = token;
    const decoded = this.appJwtHelper.decodeToken(this.token);
    this.clientId = decoded.aud;
    this.username = decoded.sub;
  }

  public setKeyPublic(key: string): void {
    this.$keyPublic.next(key);
  }

  public getKeyPublic(): any {
    return this.$keyPublic.value;
  }

  async getChannelStatus(channel: string | null): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `bearer ${this.configService.config.token.value}`,
      }),
    };

    try {
      const res: any = await firstValueFrom(
        this.http.get(ApiGateway.CHANNEL_STATUS + channel + "/status", httpOptions)
      );

      return res
    } catch (error) {
      console.error('Error al obtener ADP:', error);
      throw error;
    }

  }


async getClientADP(): Promise<any> {
  const httpOptions = {
    headers: new HttpHeaders({
      Authorization: `bearer ${this.configService.config.token.value}`,
    }),
  };

  try {
    const res: any = await firstValueFrom(
      this.http.get(ApiGateway.WFU_ADPClient, httpOptions)
    );

    return res
  } catch (error) {
    console.error('Error al obtener ADP:', error);
    throw error;
  }
}


  



  async getFingerPrint(): Promise<string> {
    const fp = await FingerprintJS.load({ debug: true });
    let fpGet = await fp.get();

    return fpGet.visitorId;
  }
}
